import React from "react";
import { useNavigate } from 'react-router-dom'

import NeedHelp from '../need-help'

interface DirectDebitSubmitButtonsProps {
  [key: string]: any
}

const DirectDebitSubmitButtons: React.FC<DirectDebitSubmitButtonsProps> = (props: any) => {

  const navigate = useNavigate()

  return (
    <>
      <div className="row">
        <div className="actions regular-submit clearfix box">
          <div className="medium-6 columns">
            <button type="submit" id="m-next-button-4dd" className="btn-cta go">Set up my direct debit</button>
            <button type="button" id="m-back-button-4dd" className="btn-cta back" onClick={() => navigate(-1)}>Back</button>
          </div>
          <div className="medium-6 columns">
            <NeedHelp />
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectDebitSubmitButtons;